export default __webpack_public_path__ + "static/media/innovator-hypothesis.38428658.svg";